"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CustomerSupportContainer = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _colors = require("HubStyleTokens/colors");

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _cindy = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/peopleBlobs/cindy.png"));

var _gyasi = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/peopleBlobs/gyasi.png"));

var _meri = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/peopleBlobs/meri.png"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

function _templateObject18() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    flex-direction: column;\n    margin-left: 0 !important;\n    > div {\n      display: flex;\n      flex-direction: row-reverse;\n      width: 100%;\n      max-width: 100%;\n      justify-content: flex-end;\n      padding: 0;\n    }\n    h5 {\n      font-size: 1em;\n      margin-left: 1em;\n      text-align: left;\n    }\n  "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  text-align: center;\n  margin-top: 49px;\n  margin-left: -32px !important;\n  margin-right: 0 !important;\n  ", ";\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  text-transform: uppercase;\n  font-weight: 500;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: none;\n  "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 20%;\n    margin-right: 5%;\n    > img {\n      display: none;\n    }\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  float: left;\n  ", ";\n  ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 65%;\n    margin-top: 0;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 580px;\n  float: right;\n  margin-top: 20%;\n  ", ";\n  ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    left: -8%;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: block !important;\n    top: 0;\n    left: 0;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  left: 220px;\n  top: 160px;\n  ", ";\n  ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin: 50px auto;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin-top: 110px;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin-top: 200px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  z-index: 1;\n  display: block;\n  margin: 140px 0;\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    font-size: 30px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-weight: bold;\n  line-height: 44px;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Title = _styledComponents.default.h1.withConfig({
  displayName: "CustomerSupport__Title",
  componentId: "sc-19faywn-0"
})(_templateObject(), _responsiveBreakpoints.default.phone(_templateObject2()));

var CustomerSupportContainer = _styledComponents.default.div.withConfig({
  displayName: "CustomerSupport__CustomerSupportContainer",
  componentId: "sc-19faywn-1"
})(_templateObject3(), _responsiveBreakpoints.default.sd(_templateObject4()), _responsiveBreakpoints.default.tablet(_templateObject5()), _responsiveBreakpoints.default.phone(_templateObject6()));

exports.CustomerSupportContainer = CustomerSupportContainer;
var GyasiImg = (0, _styledComponents.default)(_UIImage.default).withConfig({
  displayName: "CustomerSupport__GyasiImg",
  componentId: "sc-19faywn-2"
})(_templateObject7(), _responsiveBreakpoints.default.sd(_templateObject8()), _responsiveBreakpoints.default.tablet(_templateObject9()));

var WordWrapper = _styledComponents.default.div.withConfig({
  displayName: "CustomerSupport__WordWrapper",
  componentId: "sc-19faywn-3"
})(_templateObject10(), _responsiveBreakpoints.default.sd(_templateObject11()), _responsiveBreakpoints.default.tabletPortrait(_templateObject12()));

var ImageWrapper = _styledComponents.default.div.withConfig({
  displayName: "CustomerSupport__ImageWrapper",
  componentId: "sc-19faywn-4"
})(_templateObject13(), _responsiveBreakpoints.default.sd(_templateObject14()), _responsiveBreakpoints.default.tabletPortrait(_templateObject15()));

var CustomerSupportMicroCopy = (0, _styledComponents.default)(_Small.default).withConfig({
  displayName: "CustomerSupport__CustomerSupportMicroCopy",
  componentId: "sc-19faywn-5"
})(_templateObject16());
var IconsWrapper = (0, _styledComponents.default)(_UIGrid.default).withConfig({
  displayName: "CustomerSupport__IconsWrapper",
  componentId: "sc-19faywn-6"
})(_templateObject17(), _responsiveBreakpoints.default.phone(_templateObject18()));

function CustomerSupport(_ref) {
  var className = _ref.className;
  return _react.default.createElement(CustomerSupportContainer, {
    "data-selenium-id": "customer-support-container",
    className: className
  }, _react.default.createElement(ImageWrapper, null, _react.default.createElement(_UIImage.default, {
    src: _meri.default,
    width: 280
  }), _react.default.createElement(GyasiImg, {
    src: _gyasi.default,
    width: 280
  }), _react.default.createElement(_UIImage.default, {
    src: _cindy.default,
    width: 280,
    className: "m-top-8"
  })), _react.default.createElement(WordWrapper, null, _react.default.createElement(CustomerSupportMicroCopy, {
    use: "help"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "customerSupport.title"
  })), _react.default.createElement(Title, null, _react.default.createElement(_FormattedMessage.default, {
    message: "customerSupport.subtitle"
  })), _react.default.createElement("div", {
    className: "m-bottom-8"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "customerSupport.description"
  })), _react.default.createElement(IconsWrapper, null, _react.default.createElement(_UIGridItem.default, {
    size: {
      xs: 4
    }
  }, _react.default.createElement("h5", null, _react.default.createElement(_FormattedMessage.default, {
    message: "customerSupport.phoneAndEmail"
  })), _react.default.createElement(_UIIcon.default, {
    color: _colors.EERIE,
    name: "calling",
    size: 28
  })), _react.default.createElement(_UIGridItem.default, {
    size: {
      xs: 4
    }
  }, _react.default.createElement("h5", null, _react.default.createElement(_FormattedMessage.default, {
    message: "customerSupport.documentation"
  })), _react.default.createElement(_UIIcon.default, {
    color: _colors.EERIE,
    name: "blog",
    size: 28
  })), _react.default.createElement(_UIGridItem.default, {
    size: {
      xs: 4
    }
  }, _react.default.createElement("h5", null, _react.default.createElement(_FormattedMessage.default, {
    message: "customerSupport.community"
  })), _react.default.createElement(_UIIcon.default, {
    color: _colors.EERIE,
    name: "lists",
    size: 28
  })))));
}

var _default = CustomerSupport;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./js/components/common/CustomerSupport.js
// module id = 204
// module chunks = 5 6